import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { TagList } from "./TagList";

export const TagPage: FC = () => {
	return (
		<Routes>
			<Route index element={<TagList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
